// extracted by mini-css-extract-plugin
export default {"layout":"ManagerLayout_layout__1WZ0D","outletContainer":"ManagerLayout_outletContainer__A469p","outlet":"ManagerLayout_outlet__2uj8O"};